/* eslint-disable @typescript-eslint/no-explicit-any -- existing annotations; retyping would change compile behavior */
import { ReactElement } from 'react';

import MatchedVisasSideBarItemDesktop from './MatchedVisasSideBarItem-Desktop/MatchedVisasSideBarItem-Desktop';
import { placeholderVisaData } from '../../../../data/constants/constants';
import './MatchedVisasSideBar-Desktop.scss';

type MatchedVisasSideBarProps = {
    assessmentScore: any[];
};

function MatchedVisasSideBarDesktop({
    assessmentScore,
}: MatchedVisasSideBarProps): ReactElement | null {
    const isAssessmentScoreEmpty = assessmentScore.length === 0;
    const relevantData = isAssessmentScoreEmpty ? placeholderVisaData : assessmentScore;

    return (
        <div className={'MatchedVisasSideBarWrapper'}>
            <div className={'MatchedVisasSideBarTitle'}>
                {!isAssessmentScoreEmpty ? (
                    <b> Top Visas You are eligible for now</b>
                ) : (
                    <>No Visa Pathways matched yet</>
                )}
            </div>
            <div className={'MatchedVisasSideBarBody'}>
                {relevantData.map((item: any) => (
                    <MatchedVisasSideBarItemDesktop
                        key={item.country}
                        countryVisaData={item}
                        isAssessmentScoreEmpty={isAssessmentScoreEmpty}
                    />
                ))}
            </div>
            <div className={'MatchedVisasSideBarFooter'}>
                {!isAssessmentScoreEmpty && (
                    <>
                        <b> reveal your best visa pathways! </b>
                        <span>keep filling the form.</span>
                    </>
                )}
            </div>
        </div>
    );
}

export default MatchedVisasSideBarDesktop;
